export const onlyAlphaNumeric = (value: string) => value.replace(/[^a-zA-Z0-9]/g, '');

export default onlyAlphaNumeric;
